import { useSelector } from 'react-redux'

import { openModalDescriptorSelector } from '../selectors'

export function useOpenModalDescriptor() {
  return useSelector(openModalDescriptorSelector)
}
